import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingPrizeBanner } from '../../components/NewbuildingPrizeBanner';
import { getCurrentJsonQuery } from '../../selectors/location';
import { trackBannerClick, trackBannerShow } from './tracking';

const NEWBUILDING_PRIZE_URL = 'https://promo.cian.site/novostroyki-priz?cian_source=zhk_listing';

export const NewbuildingPrizeBannerContainer = () => {
  const jsonQuery = useSelector(getCurrentJsonQuery);

  const onBannerShown = React.useCallback(() => trackBannerShow(jsonQuery), [jsonQuery]);
  const onBannerClick = React.useCallback(() => trackBannerClick(jsonQuery), [jsonQuery]);

  return (
    <ActionAfterViewObserver callback={onBannerShown} triggerOnce>
      <NewbuildingPrizeBanner onClick={onBannerClick} url={NEWBUILDING_PRIZE_URL} />
    </ActionAfterViewObserver>
  );
};
